/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
(function() {
    'use strict';
    var defaults = {
        input: '.autocomplete_input',
        item: '.autocomplete_item',
        resultsContainer: '.autocomplete_results',
        closeButton: '.autocomplete_close_btn',
        eventNamespace: '.autocompleteEvent',
        launchEvent: 'launch',
        selectedEvent: 'selected',
        engineAutocompletedEvent: 'autocompleted',
        engineClearEvent: 'clear:filtered',
        focusEvent: 'focus',
        openClass: 'open',
        subTree: 'related',
        minSubTree: 2,
        enableBlur: true,
        hasFocusLaunch: true,
        tmpl: null, // Mandatory override
        tmplZero: null, // Mandatory override
        zeroMsg: null, // Mandatory override
        zeroDesc: null, // Optional override
    };
    var cons = {
        SHOW: true,
        HIDE: false,
    };

    Odigeo.UIElements.Autocomplete = function($container, engine, options) {
        this.$container = $container;
        this.engine = engine;
        this.opts = Odigeo._.defaults({}, options, defaults);
        this.results = [];
        this.token = '';
        this.resultsMap = {index: 0, relatedIndex: -1};
        this.bindEvents();
    };

    Odigeo._.extend(Odigeo.UIElements.Autocomplete.prototype, {
        bindEvents: function() {
            this.listenTo(this.engine, this.opts.engineAutocompletedEvent, this.onAutocompleted);
            this.listenTo(this.engine, this.opts.engineClearEvent, Odigeo._.partial(this.toggle, cons.HIDE));
            this.bindViewEvents();
        },

        bindViewEvents: function() {
            this.listenTo(Odigeo.Events.fake, 'fake:blur', this.onBlurInput);

            Odigeo._.each(this.getViewEvents(), function(evObj) {
                var name = (Odigeo.Events[evObj.name] || evObj.name) + this.opts.eventNamespace;

                if (!Odigeo._.isUndefined(evObj.selector)) {
                    this.$container.on(name, evObj.selector, Odigeo._.bind(this[evObj.handler], this));
                } else {
                    this.$container.on(name, Odigeo._.bind(this[evObj.handler], this));
                }
            }, this);
        },

        getViewEvents: function() {
            return [
                {name: 'tap', selector: this.opts.item, handler: 'onTapItem'},
                {name: 'tap', selector: this.opts.closeButton, handler: 'onTapCloseButton'},
                {name: 'focus', selector: this.opts.input, handler: 'onFocusInput'},
                {name: 'keyup', selector: this.opts.input, handler: 'onKeyupInput'},
            ];
        },

        render: function() {
            var renderData;
            if (Odigeo.AB.isCssVariationHeaderDesktop) {
                this.$container.removeClass('invalid');
            } else {
                this.$container.toggleClass('empty', !this.hasResults());
            }
            if (this.hasResults()) {
                renderData = this.opts.tmpl({activeIndex: this.resultsMap, results: this.results});
            } else {
                renderData = this.opts.tmplZero({msg: this.opts.zeroMsg, desc: this.opts.zeroDesc, token: this.token});
            }

            this.$container.find(this.opts.resultsContainer).html(renderData);
            this.toggle(cons.SHOW);
            this.getOpenContainer().attr('data-search', this.token);

            return this;
        },

        toggle: function(hasOpen) {
            this.getOpenContainer().toggleClass(this.opts.openClass, hasOpen);

            return this;
        },

        isOpen: function() {
            return this.getOpenContainer().hasClass(this.opts.openClass);
        },

        getOpenContainer: function() {
            return this.opts.openContainerClass ? this.$container.find(this.opts.openContainerClass) :
                this.$container;
        },

        hasResults: function() {
            return this.results.length > 0;
        },

        getActiveMap: function() {
            return Odigeo._.omit(this.resultsMap, function(value) {
                return value < 0;
            });
        },

        selectItem: function(activeMap) {
            if (this.hasResults()) {
                this.trigger(this.opts.selectedEvent, activeMap);
            }
            this.toggle(cons.HIDE);

            return this;
        },

        updateIndex: function(keyCode) {
            var isUpKey = keyCode === Odigeo.Events.keys.KEY_UP;
            var step = isUpKey ? -1 : 1;

            if (Odigeo._.isObject(this.results[this.resultsMap.index][this.opts.subTree])) {
                this.resultsMap.relatedIndex += step;
                this.checkRelatedIndexIntegrity(isUpKey, step);
            } else {
                this.resultsMap.index += step;
                this.checkIndexIntegrity(isUpKey);
            }

            this.render();

            return this;
        },

        checkIndexIntegrity: function(isUpKey) {
            var related;

            if (Odigeo._.isUndefined(this.results[this.resultsMap.index])) {
                this.resultsMap.index = this.resultsMap.index >= this.results.length ?
                    0 : this.results.length - 1;
            }
            related = this.results[this.resultsMap.index][this.opts.subTree];

            if (!isUpKey || !Odigeo._.isObject(related)) {
                this.resultsMap.relatedIndex = -1;
            } else {
                this.resultsMap.relatedIndex = related.length - 1;
            }
        },

        checkRelatedIndexIntegrity: function(isUpKey, step) {
            var related = this.results[this.resultsMap.index][this.opts.subTree];

            if (this.resultsMap.relatedIndex === -1) {
                return;
            }

            if (Odigeo._.isUndefined(related[this.resultsMap.relatedIndex])) {
                this.resultsMap.index += step;
                this.checkIndexIntegrity(isUpKey);
            }
        },

        launch: function(value) {
            this.trigger(this.opts.launchEvent, value);
        },

        getParsedResults: function(results) {
            return Odigeo._.reduce(results, function(resultsParsed, result, key) {
                var relateds = result[this.opts.subTree];
                var resultParsed = Odigeo._.omit(result, this.opts.subTree);
                resultParsed.replaced = this.getReplacedResult(result);

                if (Odigeo._.isObject(relateds) && relateds.length >= this.opts.minSubTree) {
                    resultParsed[this.opts.subTree] = Odigeo._.reduce(relateds, function(relatedParsed, related, relatedKey) {
                        relatedParsed[relatedKey] = Odigeo._.clone(related);
                        relatedParsed[relatedKey].replaced = this.getReplacedResult(related);

                        return relatedParsed;
                    }, [], this);
                }
                resultsParsed[key] = resultParsed;

                return resultsParsed;
            }, [], this);
        },

        getReplacedResult: function(result) {
            const regExp = new RegExp(Odigeo.Utils.replaceNonAlphaNumeric(this.token, '.?', true), 'igm');

            let displayName = result.displayName;
            if ( Odigeo.AB.isCssVariationHeaderDesktop ) {
                displayName = Odigeo.Utils.replacer(result.displayName, regExp);
            }

            return {
                text: Odigeo.Utils.replacer(result.text, regExp),
                country: Odigeo.Utils.replacer(result.country, regExp),
                city: Odigeo.Utils.replacer(result.city, regExp),
                displayName: displayName,
            };
        },

        onAutocompleted: function(results, token) {
            this.resultsMap = {index: 0, relatedIndex: -1};
            this.token = token;
            this.results = this.getParsedResults(results);
            this.render();
        },

        onKeyupInput: function(ev) {
            switch (ev.keyCode) {
                case Odigeo.Events.keys.KEY_RETURN:
                case Odigeo.Events.keys.KEY_TAB:
                    this.selectItem(this.getActiveMap());
                    break;
                case Odigeo.Events.keys.KEY_DOWN:
                case Odigeo.Events.keys.KEY_UP:
                    this.updateIndex(ev.keyCode);
                    break;
                default:
                    this.launch($(ev.currentTarget).val());
                    break;
            }
        },

        onTapItem: function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            this.selectItem($(ev.currentTarget).data());
        },

        onTapCloseButton: function() {
            this.selectItem(this.getActiveMap());
            this.trigger('clickCloseButton');
        },

        onFocusInput: function(ev) {
            var $input = $(ev.currentTarget);

            $input.select();

            if (this.opts.hasFocusLaunch) {
                this.launch($input.val());
            }

            this.trigger(this.opts.focusEvent);
        },

        onBlurInput: function(e) {
            if (this.opts.enableBlur && !this.$container.get(0).contains(e.target) && this.isOpen()) {
                this.selectItem(this.getActiveMap());
            }
        },

        remove: function() {
            this.$container.off(this.opts.eventNamespace);
            this.stopListening();
        },
    }, Backbone.Events);
}());
